import { Typography } from '@analytical-alley/ui';
import { cn } from '@/utils';

export type AreaTooltipProps = {
    seriesName: string;
    color: string;
    value: number;
    axisValueLabel: string;
}[];

export const AreaTooltip = ({
    params,
    selectedSeriesName,
    formatNumber,
}: {
    params: AreaTooltipProps;
    selectedSeriesName?: string;
    formatNumber: (val: number) => string;
}) => {
    if (!selectedSeriesName) {
        return null;
    }

    const hoveredItem = params.find(
        (param) => param.seriesName === selectedSeriesName,
    );

    if (!hoveredItem) {
        return null;
    }
    const selectedSeriesNameImpact =
        hoveredItem.value > 0 ? 'positive' : 'negative';

    if (selectedSeriesName === 'KPI') {
        return (
            <div className="tooltip-content">
                <table>
                    <tbody>
                        <tr>
                            <td className="pr-2">
                                <Typography className="text-black dark:text-black">
                                    Period:
                                </Typography>
                            </td>
                            <td>
                                <Typography className="text-dark dark:text-dark">
                                    {params[0]?.axisValueLabel}
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td className="pr-2">
                                <Typography className="text-black dark:text-black">
                                    Client Revenue:
                                </Typography>
                            </td>
                            <td>
                                <Typography className="text-dark dark:text-dark">
                                    {formatNumber(hoveredItem.value)}
                                </Typography>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    return (
        <div className="tooltip-content">
            <Typography className="text-violet-950 dark:text-violet-950 font-medium">
                {hoveredItem.seriesName} Media Investment on{' '}
                {params[0]?.axisValueLabel}
            </Typography>
            <Typography
                className={cn('', {
                    'text-rose-500 dark:text-rose-500':
                        selectedSeriesNameImpact === 'negative',
                    'text-green-500 dark:text-green-500':
                        selectedSeriesNameImpact === 'positive',
                })}
            >
                {`Had a ${selectedSeriesNameImpact} effect on your KPI of ${selectedSeriesNameImpact === 'negative' ? '' : '+'} ${formatNumber(hoveredItem.value)}`}
            </Typography>
        </div>
    );
};
